// Dizzplace - lista zyczen w arkuszu wysuwanym od dolu (serduszko w dolnym menu).
//
// Wzory siedza w przegladarce klienta (`window.wishlist`), wiec kafle dociagamy
// z serwera alternatywnym szablonem karty (`?view=card`) - tym samym, ktorego
// uzywa podstrona listy zyczen. Dzieki temu karta ma jeden markup w calym
// motywie, razem z serduszkiem i przyciskiem koszyka.
//
// Kafle jada w POZIOMIE: arkusz ma byc szybkim podgladem, a nie druga strona
// listy - pelna liste otwiera odnosnik "Zobacz wszystkie".

(() => {
  const TELEFON = '(max-width: 989px)';

  class WishlistDrawer extends HTMLElement {
    connectedCallback() {
      if (this.dataset.gotowy === '1') return;
      this.dataset.gotowy = '1';

      this.panel = this.querySelector('.wish-drawer__panel');
      this.tor = this.querySelector('[data-wish-drawer-track]');
      this.pusto = this.querySelector('[data-wish-drawer-empty]');
      this.baza = (this.dataset.rootUrl || '/').replace(/\/$/, '');
      this.pamiec = new Map();

      this.addEventListener('click', (zdarzenie) => {
        if (zdarzenie.target.closest('[data-wish-drawer-close]')) this.zamknij();
      });

      // Serduszko w naglowku zostaje ODNOSNIKIEM do podstrony listy zyczen -
      // na telefonie tylko przechwytujemy klikniecie i zamiast przejscia
      // otwieramy arkusz. Bez skryptu i na komputerze dziala jak dotad.
      document.addEventListener('click', (zdarzenie) => {
        const wyzwalacz = zdarzenie.target.closest('[data-wishlist-open], .wishlist-link');
        if (!wyzwalacz) return;
        if (!window.matchMedia(TELEFON).matches) return;
        zdarzenie.preventDefault();
        this.otworz();
      });

      document.addEventListener('keydown', (zdarzenie) => {
        if (zdarzenie.key === 'Escape' && !this.hidden) this.zamknij();
      });

      // Zdjecie wzoru z listy (serduszko na karcie) ma od razu zmieniac zawartosc.
      document.addEventListener('wishlist:change', () => {
        if (!this.hidden) this.wypelnij();
      });

      this.podepnijPrzeciaganieUchwytu();
    }

    async otworz() {
      this.hidden = false;
      window.dizzBlokadaTla?.zablokuj(this.panel || this);
      window.requestAnimationFrame(() => {
        this.classList.add('wish-drawer--otwarty');
        if (this.panel) this.panel.focus();
      });
      await this.wypelnij();
    }

    zamknij() {
      if (this.hidden) return;
      this.classList.remove('wish-drawer--otwarty');
      window.dizzBlokadaTla?.odblokuj();

      const koniec = () => {
        this.hidden = true;
      };

      if (this.panel) {
        this.panel.addEventListener('transitionend', koniec, { once: true });
        window.setTimeout(koniec, 400);
      } else {
        koniec();
      }
    }

    async wypelnij() {
      if (!this.tor) return;
      const magazyn = window.wishlist;
      const pozycje = magazyn ? magazyn.items() : [];

      if (this.pusto) this.pusto.hidden = pozycje.length > 0;
      this.tor.hidden = pozycje.length === 0;
      if (pozycje.length === 0) {
        this.tor.innerHTML = '';
        return;
      }

      const karty = await Promise.all(pozycje.map((pozycja) => this.karta(pozycja)));
      this.tor.innerHTML = karty
        .filter(Boolean)
        .map((html) => `<div class="wish-drawer__slide">${html}</div>`)
        .join('');
    }

    karta(pozycja) {
      const adres = new URL(`${this.baza}/products/${pozycja.h}`, window.location.origin);
      adres.searchParams.set('view', 'card');
      if (pozycja.v) adres.searchParams.set('variant', pozycja.v);
      const klucz = adres.href;

      if (!this.pamiec.has(klucz)) {
        this.pamiec.set(
          klucz,
          fetch(klucz)
            .then((odpowiedz) => (odpowiedz.ok ? odpowiedz.text() : ''))
            .catch(() => '')
        );
      }
      return this.pamiec.get(klucz);
    }

    /* Ten sam gest co w szufladzie koszyka i w arkuszu ilosci. */
    podepnijPrzeciaganieUchwytu() {
      const PROG_ZAMKNIECIA = 80;
      let startY = 0;
      let deltaY = 0;
      let przeciaga = false;

      const naRuch = (zdarzenie) => {
        if (!przeciaga || !this.panel) return;
        deltaY = Math.max(0, zdarzenie.clientY - startY);
        this.panel.style.transform = `translateY(${deltaY}px)`;
      };

      const naKoniec = () => {
        if (!przeciaga) return;
        przeciaga = false;
        if (this.panel) {
          this.panel.classList.remove('wish-drawer__panel--przeciagane');
          this.panel.style.transform = '';
        }
        if (deltaY > PROG_ZAMKNIECIA) this.zamknij();
        deltaY = 0;
      };

      this.addEventListener('pointerdown', (zdarzenie) => {
        if (!zdarzenie.target.closest('.wish-drawer__handle') || !this.panel) return;
        przeciaga = true;
        startY = zdarzenie.clientY;
        deltaY = 0;
        this.panel.classList.add('wish-drawer__panel--przeciagane');
        this.setPointerCapture(zdarzenie.pointerId);
      });
      this.addEventListener('pointermove', naRuch);
      this.addEventListener('pointerup', naKoniec);
      this.addEventListener('pointercancel', naKoniec);
    }
  }

  if (!customElements.get('wishlist-drawer')) {
    customElements.define('wishlist-drawer', WishlistDrawer);
  }
})();
